import React, { useState, useEffect } from 'react'
import {
  ModalStyled,
  Container,
  StepOne,
  StepTwo,
  ColumnStyled,
  ColumnForm,
  TitleStyled,
  Text,
  Title,
  IconCircle,
  ButtonContainer
} from './ModalPremiumLock.styles'
import { createSelfReferralMutation } from 'api/mutations'
import {
  Button as ButtonDS,
  Select,
  FontIcon as FontIconDS,
  tokens
} from '@arvoreeducacao/bonsai-ds'
import { withApollo } from '@apollo/client/react/hoc'
import { post_event } from 'utils/analytics'
import { useTranslation } from 'i18n'

const roleOptions = [
  { id: '', text: 'Selecione o cargo' },
  { id: 'Diretor(a)', text: 'Diretor(a)' },
  { id: 'Coordenador(a)', text: 'Coordenador(a)' },
  { id: 'Bibliotecário(a)', text: 'Bibliotecário(a)' },
  { id: 'Professor(a)', text: 'Professor(a)' },
  { id: 'Supervisor(a)', text: 'Supervisor(a)' },
  { id: 'Orientador(a) Educacional', text: 'Orientador(a) Educacional' },
  { id: 'Outros', text: 'Outros' }
]

const ModalPremiumLock = ({ onClose, client }) => {
  const [errors, setErrors] = useState([])
  const [role, setRoles] = useState('')
  const [step, setStep] = useState('step-one')
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    post_event('ModalPremiumLock', 'click-tenho-interesse')
  }, [])

  const handleSubmitPremiumLock = () => {
    let hasError = []

    if (!role) {
      hasError = [
        ...hasError,
        {
          field: 'role',
          helpText: 'O cargo não pode ser vazio.'
        }
      ]

      setErrors(hasError)
      return
    }

    setErrors([])
    setLoading(true)

    client
      .mutate({
        mutation: createSelfReferralMutation,
        variables: {
          role: role
        }
      })
      .then(() => {
        post_event('ModalPremiumLock', 'form-success')
        setLoading(false)
        setStep('step-two')
      })
      .catch(err => {
        setLoading(false)
        window.alert(`Oops, aconteceu um erro: ${err.message}`)
      })
  }

  return (
    <ModalStyled show={true} canCloseByXBtn={true} onClose={onClose}>
      <Container>
        <StepOne step={step}>
          <ColumnStyled lg={12}>
            <Title>{t('Qual o seu cargo?')}</Title>
          </ColumnStyled>
          <ColumnForm style={{ marginTop: '40px' }} lg={12}>
            <Select
              items={roleOptions}
              placeholder={t('Selecione o cargo')}
              onChange={option => {
                setErrors([])
                setRoles(option.id)
              }}
              error={errors.some(err => err.field === 'role')}
              helpText={
                errors.some(err => err.field === 'role')
                  ? errors.find(err => err.field === 'role').helpText
                  : ''
              }
            />
          </ColumnForm>
          <ColumnForm style={{ marginTop: '40px' }} lg={12}>
            <ButtonContainer justify={'flex-end'}>
              <ButtonDS
                primary
                loading={loading}
                disabled={loading}
                onClick={handleSubmitPremiumLock}
              >
                {t('Confirmar interesse')}
              </ButtonDS>
            </ButtonContainer>
          </ColumnForm>
        </StepOne>

        <StepTwo step={step}>
          <ColumnStyled lg={12}>
            <IconCircle>
              <FontIconDS
                size={45}
                iconName="thumbs-up"
                color={tokens.colors.purple3}
              />
            </IconCircle>
            <TitleStyled size={5}>{t('Obrigado pelo interesse!')}</TitleStyled>
            <Text>{t('Entraremos em contato em breve.')}</Text>

            <ButtonDS style={{ margin: '12px 0' }} primary onClick={onClose}>
              {t('Voltar para a Árvore')}
            </ButtonDS>
          </ColumnStyled>
        </StepTwo>
      </Container>
    </ModalStyled>
  )
}

export default withApollo(ModalPremiumLock)
